import React from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Grid } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import PropTypes from 'prop-types'
import { prop } from 'ramda'

import { CardHeader } from '~/components/Cards'
import { DiscardButton } from '~/components/Buttons'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import { withForm } from '~/components/Form'
import * as NAV from '~/constants/nav-titles'
import TextField from '~/components/Fields/TextField'
import WarehouseSearchField from '~/components/Fields/WarehouseSearchField'
import * as API from '~/constants/api'

import MovementSummary from '../../components/MovementSummary'
import MovementUpdateButton from '../MovementUpdateButton'
import MovementTable from '../MovementTable'
import { DRAFT } from '../MovementStatus'

function MovementUpdateForm (props) {
  const {
    form,
    pageTitle,
    pageTitleLoading,
    isLoading,
    scanMethods
  } = props

  const { t } = useTranslation()

  const { initialValues, handleSubmit } = form
  const status = prop('status', initialValues)

  const disabled = isLoading || status !== DRAFT

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            parentTitle={NAV.MOVEMENT}
            pageTitle={pageTitle}
            pageTitleLoading={pageTitleLoading}
            rightButton={
              <>
                <DiscardButton />
                <MovementUpdateButton
                  isLoading={isLoading || disabled}
                  onSubmit={handleSubmit}
                />
              </>
            }
          />
        </Header>

        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} lg={4}>
              <Card>
                <CardHeader title={t('Move From')} />
                <Divider />
                <CardContent>
                  <Grid container={true} spacing={3}>
                    <Grid item={true} lg={12}>
                      <WarehouseSearchField api={API.WAREHOUSE_LIST} required={true} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item={true} lg={12}>
              <Card>
                <CardHeader title={t('Stock')} required={true} />
                <Divider />
                <CardContent>
                  <MovementTable scanMethods={scanMethods} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item={true} lg={12}>
              <Grid container={true} spacing={3}>
                <Grid item={true} lg={6}>
                  <Card>
                    <CardHeader title={t('Summary')} />
                    <Divider />
                    <MovementSummary />
                  </Card>
                </Grid>
                <Grid item={true} lg={6}>
                  <Card>
                    <CardHeader title={t('Notes')} />
                    <Divider />
                    <CardContent>
                      <TextField
                        label="Notes"
                        name="notes"
                        multiline={true}
                        minRows={11}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

MovementUpdateForm.propTypes = {
  pageTitle: PropTypes.object,
  pageTitleLoading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  scanMethods: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired
}

export default withForm(MovementUpdateForm)
